module.exports = __webpack_public_path__ + "img/detalle-empleo.1fb753d0.png";